/**
* Full Screen Swap JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Screen Swap component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'full-screen-swap',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.full-screen-swap__panel' ).each( function( key, panel ) {
        const image = $( this ).find( '.fit-image img' )[0];
        const content = $( this ).find( '.full-screen-swap__panel-content' )[0];
        const height = $( this ).outerHeight();

        const contentFadeIn = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: '-25% top',
            end: '+=' + ( height * 0.3 ),
            scrub: 0,
            // markers: true,
          },
        } );
        contentFadeIn.to( content, {opacity: '1', ease: 'linear'}, 0 );

        const contentScrollUp = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: '-25% top',
            end: '+=' + height,
            scrub: 0,
            // markers: true,
          },
        } );
        contentScrollUp.to( content, {y: '-80px', ease: 'linear'}, 0 );

        if ( $( panel ).is( ':not(:last-child)' ) ) {
          const imageScrollUp = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'bottom bottom',
              end: '+=' + ( height * 0.7 ),
              scrub: 0,
              // markers: true,
            },
          } );
          imageScrollUp.to( panel, {y: '-80px', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'full-screen-swap', COMPONENT );
} )( app );
